import { defineMessages } from 'react-intl';

const scope = 'app.containers.WorkflowEditor.RehireCheckStage.ReportTestScreen';

export const reportTestMessages = defineMessages({
  report: {
    id: `${scope}.report`,
    defaultMessage: 'Report {number}',
    description: 'Safe report label when its configured name is unavailable',
  },
  foundByPhone: {
    id: `${scope}.foundByPhone`,
    defaultMessage: 'Former employee found by phone number',
    description:
      'The server confirmed the former employee through their phone number',
  },
  searching: {
    id: `${scope}.searching`,
    defaultMessage: 'Searching',
    description: 'Identity searches are still in progress',
  },
  progress: {
    id: `${scope}.progress`,
    defaultMessage: 'Running report {current} of {total}',
    description: 'Progress through the configured reports',
  },
  stale: {
    id: `${scope}.stale`,
    defaultMessage: 'Settings changed. Run the test again.',
    description:
      'The previous test no longer describes the edited configuration',
  },
  expired: {
    id: `${scope}.expired`,
    defaultMessage: 'This test expired. Run the test again.',
    description: 'An expired test result cannot be read',
  },
  refused: {
    id: `${scope}.refused`,
    defaultMessage:
      'You don’t have permission to run this test. Contact your admin to request access.',
    description: 'Current test authority was refused',
  },
  required: {
    id: `${scope}.required`,
    defaultMessage: 'Enter a value',
    description: 'A selected test input needs a value',
  },
  invalid: {
    id: `${scope}.invalid`,
    defaultMessage: 'Check this value and try again',
    description: 'A test input failed validation without echoing its value',
  },
  empty: {
    id: `${scope}.empty`,
    defaultMessage: 'Nothing returned',
    description: 'A completed report returned zero rows',
  },
  failed: {
    id: `${scope}.failed`,
    defaultMessage: 'Didn’t answer',
    description: 'A source failed, not a zero-row response',
  },
  count: {
    id: `${scope}.count`,
    defaultMessage: '{count, number} {count, plural, one {row} other {rows}}',
    description: 'Number of rows returned by a completed report',
  },
  columns: {
    id: `${scope}.columns`,
    defaultMessage: 'Columns: {columns}',
    description: 'Safe column names returned during report discovery',
  },
  discovery: {
    id: `${scope}.discovery`,
    defaultMessage: 'Map the returned columns before checking eligibility',
    description: 'Discovery alone never evaluates rehire eligibility',
  },
  ambiguous: {
    id: `${scope}.ambiguous`,
    defaultMessage: 'Needs review',
    description:
      'Identity or eligibility could not be determined unambiguously',
  },
  unavailable: {
    id: `${scope}.unavailable`,
    defaultMessage: 'Not checked',
    description: 'The check did not complete',
  },
  no_match: {
    id: `${scope}.noMatch`,
    defaultMessage: 'No match',
    description: 'Completed searches found no matching person',
  },
  current: {
    id: `${scope}.current`,
    defaultMessage: 'Current employee',
    description: 'Existing currently-employed fact, not a new verdict',
  },
  first_name_mismatch: {
    id: `${scope}.firstNameMismatch`,
    defaultMessage: 'First name doesn’t match',
    description: 'The selected first-name confirmation failed',
  },
  different_people: {
    id: `${scope}.differentPeople`,
    defaultMessage: 'Email and phone match two different people',
    description:
      'Searches identify different people, without disclosing their IDs',
  },
  no_match_details: {
    id: `${scope}.noMatchDetails`,
    defaultMessage: 'No match with these details',
    description: 'No record matches the supplied test inputs',
  },
  exact_names: {
    id: `${scope}.exactNames`,
    defaultMessage: 'Reports need exact names',
    description: 'Report filtering does not perform approximate name searches',
  },
  already_employed: {
    id: `${scope}.alreadyEmployed`,
    defaultMessage: 'Already works here',
    description: 'The confirmed person is currently employed',
  },
  all_hits_dropped: {
    id: `${scope}.allHitsDropped`,
    defaultMessage: 'Name doesn’t match',
    description: 'All retrieved identities failed the selected name checks',
  },
  blank_eligibility: {
    id: `${scope}.blankEligibility`,
    defaultMessage: 'Eligibility is blank',
    description:
      'A completed evaluation cannot determine eligibility from an empty value',
  },
  unexpected_eligibility: {
    id: `${scope}.unexpectedEligibility`,
    defaultMessage: 'Unexpected eligibility value',
    description:
      'The observed value belongs to neither configured eligibility list',
  },
  conflicting_eligibility: {
    id: `${scope}.conflictingEligibility`,
    defaultMessage: 'Eligibility values conflict. Review this applicant.',
    description:
      'Records disagree, so no decisive eligibility fact is published',
  },
});
